// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".license-information__image[data-v-1bb18cbe]{height:32px;width:32px}.license-icon__container[data-v-1bb18cbe]{width:50px}.license-icon__image[data-v-1bb18cbe]{height:40px;width:40px}.license-icon__label[data-v-1bb18cbe]{font-size:12px;font-weight:500;line-height:17px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
